module.exports = __webpack_public_path__ + "img/NoAPIKey.bc00568d.svg";